import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Send } from "@mui/icons-material";
import { Button, CircularProgress, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Downgraded } from "@hookstate/core";
import { IItemModalCallSheet } from "../../../../config/interfaces";
import {
  useAddCallSheetMutation,
  useSendCallSheetDocumentMutation,
  useUpdateCallSheetMutation,
} from "../../../../../graphql/generated/graphql";
import { useCallSheetState } from "../../../../hooks/callSheet";
import { theme } from "../../../../theme";
import ItemModalCallSheet from "./item";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  maxWidth: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "20px",
  p: 4,
  pb: 8,
};

const initialItems: IItemModalCallSheet[] = [
  {
    text: "Copy me on emails sent",
    status: false,
  },
  {
    text: "Include SMS",
    status: false,
  },
  {
    text: "Reset view counts & confirmation",
    status: false,
  },
  {
    text: "Include a message",
    status: false,
  },
];

const CallSheetModal = (props: any) => {
  const { open, onClose, data, onlySent, id } = props;
  const callSheetState = useCallSheetState();
  callSheetState.attach(Downgraded);
  const [message, setMessage] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState(initialItems);
  const [addCallSheet] = useAddCallSheetMutation();
  const [sendCallsheet] = useSendCallSheetDocumentMutation();
  const [updateCallSheet] = useUpdateCallSheetMutation();
  const navigate = useNavigate();
  const params = useParams();

  const sendCallSheet = async (id = "") => {
    const data: any = {
      callSheetId: id || props.id,
      addMeToEmailList: items[0].status,
      sendSMS: items[1].status,
      resetConfirmations: items[2].status,
      sendTest: false, //items[3].status,
      message,
    };
    const request = await sendCallsheet({ variables: data });
    if (request.data?.sendCallSheetDocument?.message === "ok") {
      onClose();
      if (props.refetch) props.refetch();
    }
  };

  useEffect(() => {
    const itemsData = items.map((item) => ({ ...item, status: false }));
    setItems(itemsData);
  }, [open]);

  const onSubmit = async () => {
    setLoading(true);
    try {
      if (onlySent) {
        await sendCallSheet();
      } else if (!data?.isEdit && data) {
        const response = await addCallSheet({
          variables: {
            ...data.data,
          },
        });
        if (response) {
          const newId = response.data?.addCallSheet?.id;
          if (newId) await sendCallSheet(newId);
          navigate(`/project/${params.projectId}/call-sheet`);
        }
      } else {
        const responseUpdate = await updateCallSheet({
          variables: {
            ...data.data,
          },
        });
        if (id) await sendCallSheet();
        if (responseUpdate) {
          navigate(`/project/${params.projectId}/call-sheet`);
        }
      }
    } catch (e: any) {
      console.error(e);
    }
    setLoading(false);
  };

  return (
    <Modal
      open={open}
      onClose={() => onClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "100%",
              padding: "1rem",
              backgroundColor: theme.palette.primary.main,
            }}
          >
            <Send
              fontSize="large"
              sx={{
                color: "#fff",
              }}
            />
          </Box>
          <Box component="br" />
          <Typography
            component="h1"
            variant="h3"
          >
            Send Call Sheet
          </Typography>
          <Typography
            component="h5"
            variant="body2"
          >
            This call sheet will be resent to 3 recipients?
          </Typography>
          <Box component="br" />
          {items.map((item: IItemModalCallSheet, index: number) => (
            <ItemModalCallSheet
              key={index}
              item={item}
              onChange={(status: boolean) => {
                const newItems = [...items];
                newItems[index].status = status;
                setItems(newItems);
              }}
            />
          ))}
          {items[3].status && (
            <textarea
              className="message-modal"
              rows={5}
              maxLength={200}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          )}
          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={loading}
            sx={{
              width: "90%",
              mt: 3,
            }}
          >
            {loading ? (
              <CircularProgress
                color="primary"
                size={20}
              />
            ) : (
              "Send to recipients"
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
export default CallSheetModal;
